
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()

    export class PoPurInvoiceDialog extends Serenity.EntityDialog<PoPurInvoiceRow, any> {
        protected getFormKey() { return PoPurInvoiceForm.formKey; }
        protected getIdProperty() { return PoPurInvoiceRow.idProperty; }
        protected getLocalTextPrefix() { return PoPurInvoiceRow.localTextPrefix; }
        protected getNameProperty() { return PoPurInvoiceRow.nameProperty; }
        protected getService() { return PoPurInvoiceService.baseUrl; }
        protected getDeletePermission() { return PoPurInvoiceRow.deletePermission; }
        protected getInsertPermission() { return PoPurInvoiceRow.insertPermission; }
        protected getUpdatePermission() { return PoPurInvoiceRow.updatePermission; }

        protected form = new PoPurInvoiceForm(this.idPrefix);
        public countcall: number;
        public diffunction: number;
        public diffg: boolean;
        public waning: boolean;
        public paymenthide: number;

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                this.calcDataOnGrid();

            });



            this.form.ShipId.changeSelect2(async e => {
                var x: string = this.form.ShipId.value
                this.form.WhsId.value = null
                if (!Q.isEmptyOrNull(x)) {
                    let a = this.form.ShipId.value
                    let whs: string = Purchase.PoShipAddressRow.getLookup().itemById[a].WhsId;

                    this.form.DtList.whsid = whs
                    console.log(whs)
                    this.form.WhsId.value = whs
                    this.form.DtList.WhsId = whs;

                    // this.form.ShipName.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipName;
                    // this.form.ShipLineAddress1.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress1;
                    // this.form.ShipLineAddress2.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress2;
                    // this.form.ShipLineAddress3.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress3;

                }
            });

            this.form.SupplierId.changeSelect2(async e => {
                var x: string = this.form.SupplierId.value

                if (!Q.isEmptyOrNull(x)) {
                    // var x :string = this.form.SupplierId.value
                    // console.log( this.form.SupplierId.value+0)
                    this.form.RefDocNo1.value = null;

                    // pass value into lookup editor and update items
                    this.form.RefDocNo1.myId = x;
                    this.form.RefDocNo1.updateItems();
                Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, false);

            
                    // select first lookup item after changing
                    // if (this.form.RefDocNo1.items && this.form.RefDocNo1.items.length > 0) {
                    //     // Serenity.EditorUtils.setValue(this.form.RefDocNo1, this.form.RefDocNo1.items[0].id);
                    // }      
                    
                    this.form.DtList.sup = x
                    this.form.DtList.supid = x
                    console.log(x + ":a")
                   
                }else{
                Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, true);

                }
            });

            this.form.TaxInvoiceNo.change(e => {
                var discStr = Q.toId(this.form.TaxInvoiceNo.value);
                if (discStr) {
                    this.disamtalocate()

                }
            });
            this.form.TaxInvoiceNo.addValidationRule(this.uniqueName, e => {
                var SupplierId = this.form.SupplierId.value;
                var TaxInvoiceNo = this.form.TaxInvoiceNo.value;
                if (SupplierId == null) {
                    return "Please select Supplier!";
                }else{

                 var h = Q.tryFirst(PoPurInvoiceRow.getLookup().items, x => x.TaxInvoiceNo == TaxInvoiceNo && x.SupplierId == SupplierId && x.CancelFg != 1)
                 console.log(h)
                 console.log(this.entity.Id)
                 if (h != null && h.Id != this.entity.Id) {   
                    Q.warning("TaxInvoiceNo already exists! in this Supplier at PI No."+h.SysDocNo)
                    return "TaxInvoiceNo already exists! in this Supplier at PI No."+h.SysDocNo;
                   
                }
                    }
                
            });

            this.form.SalesVatTypes.changeSelect2(async e => {
                let vatId = Q.toId(this.form.SalesVatTypes.value)
                if (vatId) {
                    this.form.DtList.salevattype = this.form.SalesVatTypes.value
                    this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                }
            });

            this.form.VatFg.changeSelect2(async e => {
                let fg = Q.toId(this.form.VatFg.value)
                if (fg == 1) {
                    this.form.TaxInvoiceNo.value = this.form.SysDocNo.value

                }
            });




            this.form.DiscText.change(e => {
                var discStr = Q.toId(this.form.DiscText.value);
                if (discStr) {
                    this.disamtalocate()

                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.TotalAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });


            this.form.ExciseTaxAmt.change(e => {
                var discStr = Q.toId(this.form.ExciseTaxAmt.value);
                if (discStr) {
                    this.calcVat()

                    this.form.DtList.exvat = this.form.ExciseTaxAmt.value

                }
            });



            this.form.DepositAmt.change(e => {
                var discStr = Q.toId(this.form.DepositAmt.value);
                if (discStr) {
                    this.CalPayment()

                }
            });

            this.form.PaymentDicsAmt.change(e => {
                var discStr = Q.toId(this.form.PaymentDicsAmt.value);
                if (discStr) {
                    this.CalPayment()

                }
            });

            this.form.CashOrTermfg.changeSelect2(async e => {
                let x: string = (this.form.CashOrTermfg.value)
                if (x == '0') {
                    Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DueDate, true);
                    this.form.DueDate.valueAsDate = new Date(Date.now());
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentType, false);
                    // this.form.PayTermCode.value = "เงินสด"
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, false);
                    Serenity.EditorUtils.setReadOnly(this.form.DueDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, true);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, true);

                }
            });

            // this.form.PayTermCode.changeSelect2(async e => {

            // });

            this.form.CurrencyCode.changeSelect2(async e => {
                let y: string = (this.form.CurrencyCode.value)
                if (!Q.isEmptyOrNull(y)) {
                    this.form.ExchangeRate.value = (InitialData.VexchangeRow.getLookup().itemById[y].ExchangeRate)
                    // console.log(a)

                }
            });

            this.form.CurrencyAmt.changeSelect2(async e => {
                let x = (this.form.ExchangeRate.value)
                let y = this.form.CurrencyAmt.value
                if (y >= 0) {
                    this.form.ReceiptAmt.value = y * x
                }
            });

            this.form.ExchangeRate.changeSelect2(async e => {
                let x = (this.form.ExchangeRate.value)
                let y = this.form.CurrencyAmt.value
                if (y != null) {
                    this.form.ReceiptAmt.value = y * x
                }
            });

            this.form.CusCurrencyCode.changeSelect2(async e => {
                let y: string = (this.form.CusCurrencyCode.value)
                if (!Q.isEmptyOrNull(y)) {
                    this.form.CusExchangeRate.value = (InitialData.VexchangeRow.getLookup().itemById[y].ExchangeRate)
                    // console.log(a)

                }
            });

            this.form.CusExchangeRate.changeSelect2(async e => {
                let x = (this.form.CusExchangeRate.value)
                let y = this.form.CusCurrencyAmt.value
                if (y >= 0) {
                    this.form.ReceiptAmt.value = y * x
                }
            });

            this.form.CusCurrencyAmt.changeSelect2(async e => {
                let x = (this.form.CusExchangeRate.value)
                let y = this.form.CusCurrencyAmt.value
                if (y != null) {
                    this.form.ReceiptAmt.value = y * x
                }
            });

            this.form.WhtAmt.change(e => {
                var discStr = Q.toId(this.form.WhtAmt.value);
                if (discStr) {
                    this.whsamt();

                }
            });

            this.form.CusNetAmt.changeSelect2(async e => {
                let fg = Q.toId(this.form.CusNetAmt.value)
                let ntfg = Q.toId(this.form.NetAmt.value)
                if (fg != ntfg) {
                    this.form.CusNetAmtDiff.value = fg - ntfg
                    this.checkdiffg();
                } else {
                    this.form.CusNetAmtDiff.value = 0
                    this.checkdiffg();
                }
            });

            this.form.CusVatAmt.changeSelect2(async e => {
                let fg = Q.toId(this.form.CusVatAmt.value)
                let ntfg = Q.toId(this.form.VatAmt.value)
                if (fg != ntfg) {
                    this.form.CusVatDiff.value = fg - ntfg
                    this.checkdiffg();

                } else {
                    this.form.CusVatDiff.value = 0
                    this.checkdiffg();
                }

            });




            this.form.PaymentType.changeSelect2(async e => {
                let x: string = (this.form.PaymentType.value)
                if (x == '1') { // Cash  RefType
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, true);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, true);

                    // Serenity.EditorUtils.setReadOnly(this.form.CurrencyCode, true);
                    // Serenity.EditorUtils.setReadOnly(this.form.CurrencyAmt, true);

                }
                if (x == '2' || x == '3') { // credit/debit
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, false);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, false);

                }
                if (x == '7') { // ccheck
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, true);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, false);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, false);


                }
                if (x == '8') { // transit
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, false);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, false);

                } if (x == '10') { // อื่นๆ
                    Serenity.EditorUtils.setReadOnly(this.form.RefType, true);

                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);

                    Serenity.EditorUtils.setReadOnly(this.form.BankId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, false);

                }
            });

            this.form.VatCode.changeSelect2(e => {
                var VatCode: string = Q.toId(this.form.VatCode.value);
                if (!Q.isEmptyOrNull(VatCode)) {
                    this.form.DtList.Vatchange = VatCode

                    this.dtChange();

                }
            });





        }
        private dtChange() {
            var totalAmt = 0;
            var VatAmt = 0;

            for (var i of this.form.DtList.getItems()) {
                totalAmt += i.ItemAmt || 0;
                VatAmt += i.ItemVatAmt || 0;

            }

            if (this.form.VatFg.value == "1") {
                var a = this.form.DtList.getItems().map(o => o.VatRate)

            console.log(a)
            console.log(a.length)
            if (a.length > 0) {
                var b = 0.00
                b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                if(b > 0){
                var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                this.form.VatRate.value = x.VatRate
                this.form.VatCode.value = x.VatCode
                console.log("change" + b)
                }else{
                    this.form.VatRate.value = 0;
                    this.form.VatCode.value = "V0"
                }
            }
            } else {
                this.form.VatRate.value = 0
                this.form.VatCode.value = "N"
            }

            this.form.TotalAmt.value = totalAmt;
            // this.form.DtList.TotalAmt_ = this.form.TotalAmt.value //ดรอปรันนีิ่งlinenoใหม่
            this.form.VatAmt.value = VatAmt;
            console.log("change" + VatAmt)
            // let totalAmt = this.form.TotalAmt.value;
            // let VatAmt = this.form.VatAmt.value;
            // let discamt = this.form.DiscAmt.value;
            // let salev = this.form.SalesVatTypes.value

            // this.form.NetAmt.value = totalAmt - discamt

            // if (totalAmt >= 0) {
            //     if (salev == 'I') {
            //         this.form.PurInvoiceAmt.value = totalAmt - discamt - VatAmt
            //         this.form.NetExVat.value = totalAmt - discamt - VatAmt
            //         this.form.NetTotalInVat.value = totalAmt - discamt
            //     } else {
            //         this.form.PurInvoiceAmt.value = totalAmt - discamt + VatAmt
            //         this.form.NetExVat.value = totalAmt - discamt
            //         this.form.NetTotalInVat.value = totalAmt - discamt + VatAmt
            //     }
            // }
            this.calcVat();
            // this.CalPayment();
        }
        private checkdiffg() {

            let cusnetdif = Q.toId(this.form.CusNetAmtDiff.value)
            let CusVatDiff = Q.toId(this.form.CusVatDiff.value)
            if (cusnetdif != 0 || CusVatDiff != 0) {
                this.diffg = true
                this.calcVat();
            } else {
                this.diffg = false
                this.calcVat();
            }

        }

        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }

                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    var b = 0.00
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                    if(b > 0){
                    var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                    this.form.VatRate.value = x.VatRate
                    this.form.VatCode.value = x.VatCode
                    console.log("change" + b)
                    }else{
                        this.form.VatRate.value = 0;
                        this.form.VatCode.value = "V0"
                    }
                }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
                this.form.VatAmt.value = VatAmt;
                this.calcVat();

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }

                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    var b = 0.00
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                    if(b > 0){
                    var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                    this.form.VatRate.value = x.VatRate
                    this.form.VatCode.value = x.VatCode
                    console.log("change" + b)
                    }else{
                        this.form.VatRate.value = 0;
                        this.form.VatCode.value = "V0"
                    }
                }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
                this.form.VatAmt.value = VatAmt;
                this.calcVat();

            });

        }

        private disamtalocate() {
            //20%,5%,200
            var discStr = this.form.DiscText.value;
            let a = discStr.split(",")
            console.log("before+" + this.form.TotalAmt.value)
            // this.form.DtList.TotalAmt_ = this.form.TotalAmt.value

            var totalAmts = this.form.TotalAmt.value;
            var discamt = 0
            //var net = 0

            for (var po of a) {

                if (po.includes("%")) {
                    let a = po.replace("%", "");
                    let b = Number(a);
                    console.log(b)
                    let amt = totalAmts * b / 100
                    discamt = discamt + amt;
                    totalAmts = totalAmts - amt;
                } else {
                    let x = Number(po)
                    discamt = discamt + x
                    totalAmts = totalAmts - x;
                }

            }

            console.log("Lasttotal:" + totalAmts)
            console.log("DiscAmt:" + discamt)

            this.form.DiscAmt.value = discamt

            if (discamt >= 0) {

                this.form.DtList.DisAlocate = discamt;
            }

            // this.calcVat();
            this.dtChange();
        }

        private calcVat() {
            let totalAmt = this.form.TotalAmt.value;
            let VatAmt = this.form.VatAmt.value;
            let discamt = this.form.DiscAmt.value;
            let exvat = this.form.ExciseTaxAmt.value ?? 0


            let net = totalAmt - discamt
            this.form.NetAmt.value = net;
            console.log(totalAmt)
            if (totalAmt > 0) {
                if (this.form.SalesVatTypes.value == 'I') {
                    this.form.PurInvoiceAmt.value = totalAmt - discamt - VatAmt + exvat
                    this.form.NetExVat.value = totalAmt - discamt - VatAmt
                    this.form.NetTotalInVat.value = totalAmt - discamt + exvat
                } else {
                    this.form.PurInvoiceAmt.value = totalAmt - discamt + VatAmt + exvat
                    this.form.NetExVat.value = totalAmt - discamt
                    this.form.NetTotalInVat.value = totalAmt - discamt + VatAmt + exvat
                }
            }
            else{
                this.form.PurInvoiceAmt.value = 0
                this.form.NetExVat.value = 0
                this.form.NetTotalInVat.value = 0
            }
            console.log(this.diffg + "diffg")
            if (this.diffg == false) {
                this.form.CusNetAmt.value = net
                this.form.CusVatAmt.value = VatAmt
                this.form.CusPurInvoiceAmt.value = this.form.PurInvoiceAmt.value
                this.form.CusVatDiff.value = 0;
                this.form.CusNetAmtDiff.value = 0;
            } else {

                let cusamt = this.form.CusNetAmt.value
                let cusVatAmt = this.form.CusVatAmt.value;
                if (totalAmt > 0) {
                    if (this.form.SalesVatTypes.value == 'I') {
                        this.form.CusPurInvoiceAmt.value = cusamt - cusVatAmt + exvat
                        this.form.NetTotalInVat.value = cusamt + exvat

                    } else {

                        this.form.CusPurInvoiceAmt.value = cusamt + cusVatAmt + exvat
                        this.form.NetTotalInVat.value = cusamt + cusVatAmt + exvat
                    }
                }

            }

            this.CalPayment();

        }

        private CalPayment() {
            var puramt = 0;

            // if (this.diffg == false) {
            //     puramt = this.form.PurInvoiceAmt.value
            // } else {
            //     puramt = this.form.CusPurInvoiceAmt.value
            // }
            puramt = this.form.NetTotalInVat.value

            let dispo = this.form.DepositAmt.value ?? 0;

            // console.log(dispo)            
            let before = puramt - (dispo ?? 0)

            this.form.PaymentBeforeDisc.value = before

            // let CashOrTermfg = this.form.CashOrTermfg.value
            // if(CashOrTermfg == '0'){
            let dis = this.form.PaymentDicsAmt.value ?? 0;


            let amt = before - dis
            this.form.PaymentAmt.value = amt

            if (this.paymenthide == 0) {
                let wht = amt * (3 / 100)
                this.form.WhtAmt.value = wht
            } else {
                this.form.WhtAmt.value = 0
            }



            this.whsamt();

        }

        private whsamt() {

            let wht = this.form.WhtAmt.value
            let amt = this.form.PaymentAmt.value
            this.form.PaymentNetAmt.value = amt - wht
            let net = amt - wht

            this.form.BalanceAmt.value = net - (this.form.ReceiptAmt.value ?? 0)
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

                let send: Serenity.ToolButton =
                {
                    title: "Send Approve",
                    hint: "Send to approve",
                    separator: false,
                    cssClass: "button-sendapp",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;

                        if( this.form.DtList.getItems().length == 0){
                            
                                Q.alert("ไม่มีรายการสินค้า");
                                return;
                            
                        }

                        if (this.diffunction == 1) {
                            this.waning = this.checktrnDiff();

                        }
                        if (this.waning == true) {
                            this.waning = false;
                        } else {

                            // this.disamtalocate();

                            if (this.validateForm() && this.validateBeforeSave()) {
                                var options = this.getSaveOptions((response) => {

                                    if (this.isEditMode()) {
                                        var id1 = response.EntityId;
                                        if (id1 == null) {
                                            id1 = this.get_entityId();
                                        }
                                        var a = this.loadById(id1);
                                    }
                                    else {
                                        var a = this.loadById(response.EntityId);
                                    }

                                    Q.confirm('ยืนยันส่งอนุมัติเอกสาร'
                                        , () => {
                                            this.form.SendForAppfg.value = "1";


                                            var options = this.getSaveOptions((respons2) => {

                                                if (this.isEditMode()) {
                                                    var id1 = respons2.EntityId;
                                                    if (id1 == null) {
                                                        id1 = this.get_entityId();
                                                    }
                                                    this.loadById(id1);
                                                }
                                                else {
                                                    this.loadById(respons2.EntityId);
                                                    // this.dialogClose();
                                                }

                                                this.showSaveSuccessMessage(respons2);


                                            });



                                            options.onError = function (respons2) {
                                                Q.alert(respons2.Error.Message);
                                            }

                                            Q.serviceCall(options);




                                        });


                                });

                                options.onError = function (response) {
                                    Q.alert(response.Error.Message);
                                }

                                Q.serviceCall(options);
                            } else {
                                this.save((response) => {
                                    this.dialogClose();
                                });


                            }

                        }
                    }
                };
                buttons.push(send);

                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "SAVE",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;

                        if( this.form.DtList.getItems().length == 0){
                            
                            Q.alert("ไม่มีรายการสินค้า");
                            return;
                        
                         }

                        if (this.diffunction == 1) {
                            this.waning = this.checktrnDiff();

                        }
                        if (this.waning == true) {
                            this.waning = false;
                        } else {


                            

                            if (this.validateForm() && this.validateBeforeSave()) {
                                var options = this.getSaveOptions((response) => {

                                    if (this.isEditMode()) {
                                        var id1 = response.EntityId;
                                        if (id1 == null) {
                                            id1 = this.get_entityId();
                                        }
                                        this.loadById(id1);
                                    }
                                    else {
                                        if (this.isNew()) {
                                            this.dialogClose();
                                        } else {
                                            this.loadById(response.EntityId);

                                        }
                                    }

                                    this.showSaveSuccessMessage(response);


                                });

                                options.onError = function (response) {
                                    if (response.Error.Message.includes("Can't save record. There is another record")) {
                                        Q.alert(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                        var s = self.form.SysDocNo.value
                                        var f = s.substring(0, 9)
                                        GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber({
                                            Prefix: f,
                                            Length: 15
                                        }, response => {

                                            self.form.SysDocNo.value = response.Serial;

                                        });
                                    } else { Q.alert(response.Error.Message); }



                                }

                                Q.serviceCall(options);
                            } else {
                                // this.save((response) => {
                                //     this.dialogClose();
                                // });


                            }

                        }
                    }
                };
                buttons.push(newSaveBtn);




                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            // this.doDelete(() => {

                            //     this.dialogClose();
                            // });
                            this.form.CancelFg.value = "1";
                            this.save((response) => {
                                this.dialogClose();
                            });

                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


            let realocate: Serenity.ToolButton =
            {
                title: "",
                hint: "recall",
                separator: false,
                cssClass: "recall",
                icon: "fa fa-undo-alt",

                onClick: (e) => {
                    this.disamtalocate()
                }
            };
            buttons.push(realocate);

            let CallPR: Serenity.ToolButton =
            {
                title: "",
                hint: "call PO detail",
                cssClass: "callpr",
                icon: "fa fa-level-down-alt",

                onClick: (e) => {

                    let orderNo = this.form.RefDocNo1.value
                    if (!Q.isEmptyOrNull(orderNo)) {



                        var id = Q.tryFirst(PoPurOrderRow.getLookup().items, x => x.SysDocNo == orderNo).SysDocNo;

                        PoPurOrderService.Retrieve({ EntityId: id }, response => {
                            this.setHdDetails(response.Entity);
                            this.form.DtList.CallPR = this.form.RefDocNo1.value;

                            this.disamtalocate();
                        }
                        )



                    }

                }
            };
            buttons.push(CallPR);
            if(!this.isNew()){
            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                        // this.save((response) => {


                        // const self = this;
                        // var request = self as PoPurOrderPrintData;
                        const request: PoPurInvoicePrintData = {};

                        request.SysDocNo = this.form.SysDocNo.value
                        request.Header = Q.tryFirst(PoPurInvoiceRow.getLookup().items, x => x.SysDocNo == this.form.SysDocNo.value)
                        let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)

                        if (fg != null) {
                            let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.form.ShopId.value)
                            request.BizName = s.ShopRegName
                            request.BizAddressLine1 = s.ShopRegAddressLine1
                            request.BizAddressLine2 = s.ShopRegAddressLine2
                            request.BizAddressLine3 = s.ShopRegAddressLine3
                            request.TaxId = s.ShopTaxId
                        } else {

                            let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                            request.BizName = q.BizName
                            request.BizAddressLine1 = q.TaxInvAddrLine1
                            request.BizAddressLine2 = q.TaxInvAddrLine2
                            request.BizAddressLine3 = q.TaxInvAddrLine3
                            request.TaxId = q.BizName
                        }
                        request.Supdata = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x => x.SupplId == this.form.SupplierId.value)
                        let x =  Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == this.entity.PayTermCode);
                        if(x !=null){
                                request.payment = x.CreditTerm.toString() ;
                            }else {
                                request.payment = ''
                            }
                             let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if (p != null) {
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Purchase/PoPurInvoiceedit/"+this.entity.SysDocNo, "")
                            request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen
                        } else {
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }
                        let o = this.entity.PayTermCode
                        if(!Q.isEmptyOrNull(o)){
                            request.Paydesc = Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == this.entity.PayTermCode).PayTermDesc
                        }else {
                            request.Paydesc = ''
                        }
                        console.log(request)

                        var fgApp = 0;
                        let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 33 && x.SysFg > 0)
                        if (lookupconsignfg != null) {
                            let c = this.entity.ApproveFg;
                            if (c == 1) {
                                fgApp = 0;
                            } else {
                                fgApp = 1;
                            }
                        }

                        if (fgApp == 0) {

                            Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                            // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                        } else {
                            Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                        }
                        // });
                    },

                }
            );
            }


            return buttons;


        }



        public setHdDetails(details: PoPurOrderRow) {
            //hd
            this.form.ShipId.value = String(details.ShipId ?? '');

            this.form.WhsId.value = String(details.WhsId ?? '');
            this.form.SupplierId.value = String(details.SupplierId ?? '') ?? '';
            this.form.ShipDate.value = String(details.ShipDate ?? '');
            this.form.BranchCode.value = String(details.BranchCode ?? '');
            // this.form.ShipLineAddress2.value = String(details.ShipLineAddress2);
            // this.form.ShipLineAddress3.value = String(details.ShipLineAddress3);
            
            this.form.PayTermCode.value = String(details.PayTermCode ?? '') ?? '';
            if (details.PayTermCode == "Cash") {
                this.form.CashOrTermfg.value = "0"
                this.form.DueDate.valueAsDate = new Date(Date.now());
            } else {
                this.form.CashOrTermfg.value = "1"
                let x: string = (this.form.PayTermCode.value)
                console.log("paytrem:" + x)
                if (!Q.isEmptyOrNull(x)) {
                    let a = (Lookups.VwPaytermCodeLookupRow.getLookup().itemById[x].CreditTerm) || 0
                    this.form.DueDate.valueAsDate = new Date(Date.now() + a);
                    // Q.formatDate(v1, "dd/MM/yyyy")

                    // this.form.DueDate.value = (new Date(new Date().setDate(new Date().getDate()+a))).toDateString();
                    console.log(new Date(Date.now() + a))
                    console.log(a)
                    //Serenity.EditorUtils.setReadOnly(this.form.PartnerCompensatePc, !isPsCashCouponValueType1);

                }
            }
            this.form.POTypeFg.value = String(details.POTypeFg ?? '');
            this.form.VatFg.value = String(details.VatFg ?? "1");
            let x = String(details.SalesVatTypes ?? '');
            if (!Q.isEmptyOrNull(x)) {
                this.form.SalesVatTypes.value = x
                this.form.DtList.salevattype = this.form.SalesVatTypes.value
                //this.form.DtList.salevatetype = this.form.SalesVatTypes.value
            }
            //foot
            this.form.Remark.value = String(details.Remark ?? '');
            console.log("DiscText: " + details.DiscText);
            this.form.DiscText.value = String(details.DiscText ?? '');

            this.form.DepositAmt.value = details.DepositAmt ?? 0;



            // 
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.waning = false;
            this.diffg = false;

            this.form.DtList.myPassValue = this.form.SysDocNo.value
            this.form.DtList.supid = this.form.SupplierId.value
            this.form.DtList.whsid = this.form.WhsId.value
            this.form.DtList.salevattype = this.form.SalesVatTypes.value

            this.syscuscheck();

            if (this.isNew()) {
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                this.form.ShopId.value = userId.ShopId
                this.form.DtList.shopid = userId.ShopId
                this.getNextNumber();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('delete-button').hide();



            }else{
                Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
            }
            this.toolbar.findButton('recall').insertAfter(this.form.DiscText.element)
            this.toolbar.findButton('callpr').insertAfter(this.form.RefDocNo1.element)



            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.ApproveFg == 1 || this.entity.ApproveFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                this.toolbar.findButton('bt-approve').hide();
                this.toolbar.findButton('bt-reject').hide();
                this.toolbar.findButton('bt-Return').hide();
                this.form.RefDocNo1.getGridField().toggle(false);
                this.form.ConcatRefDocNo1.getGridField().toggle(true);
                // this.form.DtList.Appfg = true
                this.form.DtList.set_readOnly(true);
                this.appreadonly()
            } if (this.entity.SendForAppfg == 1) {
                // this.form.DtList.Appfg = true
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('button-save').hide();
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                this.form.DtList.set_readOnly(true);
                this.appreadonly()



            } else {
                // this.form.DtList.Appfg = false


            }
            let potype = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 69 && x.SysFg > 0)          

            if (potype != null) {
                // this.potypefg = 1;
                this.form.POTypeFg.getGridField().toggle(true);
            } else {
                // this.potypefg = 0;
                this.form.POTypeFg.getGridField().toggle(false);
            }

        }

        private appreadonly() {
            // this.form.PurDocNo.set_readOnly(true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvoiceNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipId, true);
            Serenity.EditorUtils.setReadOnly(this.form.WhsId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
            Serenity.EditorUtils.setReadOnly(this.form.TaxInvoiceDate, true);

            Serenity.EditorUtils.setReadOnly(this.form.Remark, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);

            Serenity.EditorUtils.setReadOnly(this.form.CashOrTermfg, true);
            Serenity.EditorUtils.setReadOnly(this.form.DepositAmt, true);

            Serenity.EditorUtils.setReadOnly(this.form.DueDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentType, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefType, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentDicsRemark, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentDicsAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.BankId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PaymentRefNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.WhtAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CurrencyCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.ExchangeRate, true);
            Serenity.EditorUtils.setReadOnly(this.form.CurrencyAmt, true);

            Serenity.EditorUtils.setReadOnly(this.form.CusNetAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusVatAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusPurInvoiceAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusNetAmtDiff, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusVatDiff, true);


            Serenity.EditorUtils.setReadOnly(this.form.CusCurrencyAmt, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusCurrencyCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.CusExchangeRate, true);


        }

        protected getSaveEntity(): PoPurInvoiceRow {
            let entity = super.getSaveEntity();

            return entity;
        }


        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                // console.log('User Id : ' + userId.ShopId);

                // this.form.ShopId.value = userId.ShopId
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "12").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.PurIvNo.value = response.Serial;
                    this.form.DocDate.element.focus();
                });
            }

        }

        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 3 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.SalesVatTypes.getGridField().toggle(true);
            } else {
                this.form.SalesVatTypes.getGridField().toggle(false);
            }

            let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 64 && x.SysFg > 0)
            console.log(vatfg)
            if (vatfg != null) {
                this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.VatFg.getGridField().toggle(false);
            }


            let distext = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 31 && x.SysFg > 0)
            // console.log(vatfg)
            if (distext != null) {
                Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
                this.toolbar.findButton('recall').hide();
            } else {

            }
            let amtorvatdif = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 4 && x.SysFg > 0)
            console.log(amtorvatdif)
            if (amtorvatdif != null) {
                this.diffunction = 1
                this.diffg = false;

            } else {
                this.diffunction = 0
                this.form.CusNetAmt.getGridField().toggle(false);
                this.form.CusVatAmt.getGridField().toggle(false);
                this.form.CusPurInvoiceAmt.getGridField().toggle(false);
                this.form.CusNetAmtDiff.getGridField().toggle(false);
                this.form.CusVatDiff.getGridField().toggle(false);
            }
            let cur2 = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 6 && x.SysFg > 0)
            console.log(cur2)
            if (cur2 != null) {


            } else {
                this.form.CusCurrencyCode.getGridField().toggle(false);
                this.form.CusExchangeRate.getGridField().toggle(false);
                this.form.CusCurrencyAmt.getGridField().toggle(false);
            }
            let docdate = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 40 && x.SysFg > 0)
            // console.log(vatfg)
            if (docdate != null) {
                Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            } else {

            }
            let hidePayment = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 25 && x.SysFg > 0)

            if (hidePayment != null) {
                this.paymenthide = 1
                this.form.DepositAmt.getGridField().toggle(false);
                this.form.PaymentBeforeDisc.getGridField().toggle(false);
                this.form.PaymentType.getGridField().toggle(false);
                this.form.RefType.getGridField().toggle(false);
                this.form.PaymentDicsRemark.getGridField().toggle(false);
                this.form.PaymentDicsAmt.getGridField().toggle(false);

                this.form.ChequeNo.getGridField().toggle(false);
                this.form.ChequeDate.getGridField().toggle(false);
                this.form.PaymentAmt.getGridField().toggle(false);

                this.form.BankId.getGridField().toggle(false);
                this.form.PaymentRefNo.getGridField().toggle(false);
                this.form.WhtAmt.getGridField().toggle(false);

                this.form.CurrencyCode.getGridField().toggle(false);
                this.form.ExchangeRate.getGridField().toggle(false);
                this.form.CurrencyAmt.getGridField().toggle(false);

                this.form.PaymentNetAmt.getGridField().toggle(false);
                this.form.CusCurrencyCode.getGridField().toggle(false);
                this.form.CusExchangeRate.getGridField().toggle(false);
                this.form.CusCurrencyAmt.getGridField().toggle(false);
                this.form.ReceiptAmt.getGridField().toggle(false);
                this.form.BalanceAmt.getGridField().toggle(false);

            } else {
                this.paymenthide = 0

            }
            let extax = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 44 && x.SysFg > 0)
            console.log("extax" + extax)
            if (extax != null) {
                this.form.ExciseTaxAmt.getGridField().toggle(true);
                // this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.ExciseTaxAmt.getGridField().toggle(false);
                // this.form.VatFg.getGridField().toggle(false);
            }

        }


        private checktrnDiff() {
            let para = Q.first(Purchase.PoParaRow.getLookup().items, x => x.Id == 1)
            if (this.form.CusNetAmtDiff.value > para.ToleranceTotal) {
                Q.warning("ส่วนต่างยอดรวม เกินจำนวนที่กำหนด")
                return true
            }
            if (this.form.CusNetAmtDiff.value < para.ToleranceTotal * -1) {
                Q.warning("ส่วนต่างยอดรวม เกินจำนวนที่กำหนด")

                return true
            }
            if (this.form.CusVatDiff.value > para.ToleranceVat) {
                Q.warning("ส่วนต่างภาษี เกินจำนวนที่กำหนด")
                return true
            }
            if (this.form.CusVatDiff.value < para.ToleranceVat * -1) {
                Q.warning("ส่วนต่างภาษี เกินจำนวนที่กำหนด")
                return true
            }
            return false
        }


    }
}